import { render, staticRenderFns } from "./CompPoints.vue?vue&type=template&id=342182ce&scoped=true"
import script from "./CompPoints.vue?vue&type=script&lang=js"
export * from "./CompPoints.vue?vue&type=script&lang=js"
import style0 from "./CompPoints.vue?vue&type=style&index=0&id=342182ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342182ce",
  null
  
)

export default component.exports